// Helpers puros del ledger de Anexo — compartidos entre Desarrollos y, más
// adelante, la Encomienda de viajero. Sin red, sin tenant, sin estado: solo
// ordenan y aplanan la forma anidada packages[].items[].

// Orden del Anexo: sort_order ASC, created_at ASC como desempate. La base ya
// devuelve así, pero el orden se reafirma acá para no depender del llamador.
export const ordenarPaquetes = (packages) =>
  [...(packages || [])].sort((a, b) => {
    const d = (a.sort_order ?? 0) - (b.sort_order ?? 0);
    if (d !== 0) return d;
    return String(a.created_at || '').localeCompare(String(b.created_at || ''));
  });

// Todos los artículos, sin importar el paquete — para totales y validaciones.
export const aplanarItems = (packages) =>
  (packages || []).flatMap((p) => p.items || []);
